var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @file: native.ts
 * @desc: Native Monitor log
 * @author: zhangdaming.yida@bytedance.com
 */
import via from '@bridge/byted-via-tiktok';
import compatibleSlardar from '@lib/slardar';
export var nativeMonitor = function (params, slardarParams) {
    var _a;
    var defaultParams = __assign(__assign({ log_type: 'service_monitor' }, params), ((_a = slardarParams === null || slardarParams === void 0 ? void 0 : slardarParams.slardarTags) !== null && _a !== void 0 ? _a : {}));
    console.log('=== Native Monitor Log ====', defaultParams);
    // @ts-ignore
    via.app.monitorLog(defaultParams);
    compatibleSlardar.customReport('api_report', __assign({}, defaultParams), slardarParams === null || slardarParams === void 0 ? void 0 : slardarParams.slardarMetrics);
};
